interface IIndexable {
  [key: string]: any;
}

// Keys should match to env
export const dappBannerMappings: IIndexable = {
  // MATIC: {
  //   text: "Maximize your return on Matic with ~13% APY by providing liquidity to the Matic-MaticX pool on QuickSwap",
  //   link: "https://quickswap.exchange/#/farm?tab=eternal-farms",
  //   show: true,
  //   ctaText: "Stake now",
  // },
  ETH: {
    text: "Ethx Beta Release: Test on Goerli Eth Network, avoid staking Eth tokens",
    textSafeMode:
      "Safe mode : Withdrawal request finalizations are paused until the reconciliation of slashing/inactivity leaks on the Ethereum blockchain",
    // link: "https://quickswap.exchange/#/farm?tab=eternal-farms",
    show: true,
    isClosable: false,
    type: "info",
    // ctaText: "Stake now",
  },
};
